import {FilterHelper} from '../helpers/FilterHelper';

/**
 * Дописывает в хэш обязательное условие фильтра, если его там нет.
 *
 * Нужен там, где API отчёта отвечает 400 без этого условия: хэш читают независимо
 * KSTable (он формирует первый запрос в API, KSTable.vue:271) и KSFilter (панель
 * фильтров, KSFilter.vue:663), поэтому править надо сам хэш — до того, как
 * смонтируются оба. created() родителя выполняется раньше создания и монтирования детей.
 *
 * Компонент задаёт `requiredFilter`, например 'status=1'. Имя поля берётся из него же.
 */
export default {
    created() {
        this.ensureRequiredFilterInHash();
    },
    methods: {
        ensureRequiredFilterInHash() {
            const required = this.requiredFilter;
            if (!required) {
                return;
            }

            const field = FilterHelper.fieldName(required);
            if (!field) {
                return;
            }

            const parts = window.location.hash.replace(/^#+/, '').split('&').filter(Boolean);
            const index = parts.findIndex(part => part.split('=')[0] === 'filter');
            const current = FilterHelper.decode(index === -1 ? '' : parts[index].slice('filter='.length));

            // поле уже в фильтре (в том числе как OR-условие) — хэш не трогаем.
            // Здесь проверка мягче, чем FilterHelper.hasOnlyField: задача не в том, чтобы
            // повторить контракт бэкенда, а в том, чтобы не дописать условие второй раз
            if (new RegExp(`(^|\\^)(OR)?${field}(?![a-zA-Z0-9_])`).test(current)) {
                return;
            }

            const merged = FilterHelper.encode(current ? `${required}^${current}` : required);

            if (index === -1) {
                parts.push(`filter=${merged}`);
            } else {
                parts[index] = `filter=${merged}`;
            }

            // replaceState, а не location.hash: иначе в истории появится лишний шаг
            // и кнопка «назад» будет возвращать на страницу без фильтра
            history.replaceState(
                null,
                '',
                `${window.location.pathname}${window.location.search}#${parts.join('&')}`
            );
        },
    },
}
